import * as types from "@/store/mutationTypes";
import { UserPermissions } from "@/utils/userInfo";
const PaymentCancellationModal = () => import(/* webpackChunkName: "activities" */ '@/components/modals/PaymentCancellationModal');

export const actions = {
  openModal: ({ commit }, payload) => {
    const userInfo = UserPermissions.getUserInfoFromLocalStorage();

    if (!!userInfo || payload.options.isSchool) {
      const { modal, options, callback } = payload;
      setTimeout(() => {
        commit(types.SET_MODAL, modal ? modal : payload);
        options && commit(types.SET_OPTIONS, options);
        callback && commit(types.SET_ON_CLOSE_CALLBACK, callback);
      });

      document.body.classList.add("stop-scrolling");
    }
  },

  closeModal: ({ commit, state, dispatch }, payload) => {
    const dangerClose = payload && payload.dangerClose;
    if (state.options && state.options.notClosable && !dangerClose) {
      return;
    }
    if (state.options && state.options.confirmOnClose && !dangerClose) {
      dispatch("openModal", {
        modal: PaymentCancellationModal,
        options: {
          backToModal: state.modal,
          backToModalOptions: state.options,
          notClosable: true,
          fade: true,
          isWaitlistCancellation: state.options.isWaitlistFlow,
          rosterDay: state.options.rosterDay,
        },
      });
      dispatch("toggleFade", true);
      return;
    }
    commit(types.SET_ON_CLOSE_CALLBACK, null);
    commit(types.SET_MODAL, null);
    commit(types.SET_OPTIONS, null);

    document.body.classList.remove("stop-scrolling");
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/modalWindow/actions.js